const ReCaptchaStatement: React.FC = () => (
  <p
    className="max-w-[50ch] self-center text-sm text-center text-gray"
    data-testid="recaptcha-statement"
  >
    This site is protected by reCAPTCHA and the Google{" "}
    <a
      aria-label="Google‘s Privacy Policy"
      className="text-blue900 underline"
      href="https://policies.google.com/privacy"
    >
      Privacy Policy
    </a>{" "}
    and{" "}
    <a
      className="text-blue900 underline"
      href="https://policies.google.com/terms"
    >
      Terms of Service
    </a>{" "}
    apply.
  </p>
);

export default ReCaptchaStatement;
